import React from "react";

//This is a simple component that takes an array of images and creates a carrousel with them
export function Carrousel(props: { images: string[] }) {
  const [index, setIndex] = React.useState(0);
  if (!props.images || !props.images.length) return null;
  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        overflow: "hidden",
      }}
    >
      <div
        style={{
          width: `${props.images.length * 100}%`,
          transform: `translateX(-${(index * 100) / props.images.length}%)`,
          transition: "transform 0.5s ease-in-out",
          display: "flex",
          alignItems: "center",
        }}
      >
        {props.images.map((x) => (
          <img
            src={"https://havorredlimfjorden.dk" + x}
            alt="creek"
            style={{
              width: `${100 / props.images.length}%`,
              height: "auto",
              objectFit: "contain",
              objectPosition: "center",
              display: "inline-block",
            }}
          />
        ))}
      </div>
      {props.images.length > 1 && (
        <>
          <button
            onClick={() => setIndex((index + 1) % props.images.length)}
            style={{
              position: "absolute",
              right: 0,
              top: "50%",
              transform: "translateY(-50%)",
              background: "#FFFFFFAA",
              border: 0,
              height: "30px",
              width: " 30px",
              borderRadius: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              margin: "0 4px",
            }}
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path d="M16.1716 10.9999L10.8076 5.63589L12.2218 4.22168L20 11.9999L12.2218 19.778L10.8076 18.3638L16.1716 12.9999H4V10.9999H16.1716Z" />
            </svg>
          </button>
          <button
            onClick={() => setIndex((index - 1) % props.images.length)}
            style={{
              position: "absolute",
              left: 0,
              top: "50%",
              transform: "translateY(-50%)",
              background: "#FFFFFFAA",
              border: 0,
              height: "30px",
              width: " 30px",
              borderRadius: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              margin: "0 4px",
            }}
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path d="M7.82843 10.9999H20V12.9999H7.82843L13.1924 18.3638L11.7782 19.778L4 11.9999L11.7782 4.22168L13.1924 5.63589L7.82843 10.9999Z" />
            </svg>
          </button>
        </>
      )}
    </div>
  );
}
